import React from 'react';
import { Button } from '@mui/material';
import { CANVA_REDIRECT_ORIGIN, CANVA_REDIRECT_URI } from './canvaOAuthConfig';

class LoginWithCanvaButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupWindow: null, // To track the popup
    };
  }

  handleOpenPopup = () => {
      console.log("handleOpenPopUp");
      const { popupWindow } = this.state;

      // Check if popup is already open and not closed
      if (popupWindow && !popupWindow.closed) {
        //console.log("Popup already open. Focusing...");
        popupWindow.focus();
        return;
      }

      // Open the popup window
      const popupUrl = `${CANVA_REDIRECT_URI}?opener_origin=${encodeURIComponent(window.location.origin)}`;
      const newPopup = window.open(
        popupUrl,
        'CanvaPopup',
        'width=600,height=700'
      );

      if (newPopup) {
          this.setState({ popupWindow: newPopup });
          // Listen for messages from the popup
          window.addEventListener('message', this.handlePopupMessage, false);
      } else {
        //console.log("popup could not be opened. please disable popup blockers");
        alert("Popup could not be opened. Please disable popup blockers.");
      }
  };

  handlePopupMessage = (event) => {
      // Validate message origin (important for security)
      if (event.origin !== CANVA_REDIRECT_ORIGIN) {
        //alert("untrusted origin");
        console.warn("Untrusted origin:", event.origin);
        console.log("xdata="+JSON.stringify(event.data));
        return;
      }

      if (event.data?.type === 'canva_popup_ready') {
        this.state.popupWindow?.postMessage({
          type:'canva_oauth_init',
          userId:localStorage.getItem('etv.user_id'),
          accessToken:localStorage.getItem('etv.access_token'),
        }, CANVA_REDIRECT_ORIGIN);
        return;
      }

      const { tokenData } = event.data;
      console.log("tokenData="+tokenData+" tokendata="+JSON.stringify(tokenData));
      if (tokenData) {
        console.log("---->Access token received:", tokenData);
        this.props.onAccessTokenReceived(tokenData);
        // Clean up
        window.removeEventListener('message', this.handlePopupMessage, false);
        if (this.state.popupWindow) {
            this.state.popupWindow.close();
            this.setState({ popupWindow: null });
        }
      }else{
        console.log("xx no tokendata");
      }
  };

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePopupMessage, false);
    if(this.state.popupWindow && !this.state.popupWindow.closed) this.state.popupWindow.close();
  }

  render() {
    return (
      <Button 
          startIcon={<img src='/logo/Canva_Icon_logo.svg' width='20' height='20' alt=''/>} 
          variant="outlined" 
          onClick={this.handleOpenPopup}
      >
        Canva Import
      </Button>
    );
  }
}

export default LoginWithCanvaButton;
